export default __webpack_public_path__ + "static/pivoting-501718d7b59fc70aad9f678212064e65.gif";